import {INITIAL_FORM_VALUES} from 'desktop/pages/checkout/constants/checkout';
import {CustomerAddressType} from 'desktop/types/customerAddressesType';

import {StatesItemType} from 'types/locationType';

import {
    applyAssociations,
    AssociationsResultType,
    customerAddressAssociations,
} from '../applyAssociations/applyAssociations';

/**
 * Modify addresses list using customer addresses and states
 * @param {Array<CustomerAddressType>} addresses - Customer addresses to decompose
 * @param {Array<Array<StatesItemType>>} states - States for decompose
 * @return {AssociationsResultType[]} Addresses list for saving to store
 */
export const getPreparedAddresses = (
    addresses: Array<CustomerAddressType>,
    states: Array<Array<StatesItemType>>,
): AssociationsResultType[] =>
    addresses.map((address, index) =>
        applyAssociations(customerAddressAssociations, address, {
            country: ({value}) => ({
                value: value || INITIAL_FORM_VALUES.country.value,
            }),
            regionCode: ({value}) => {
                const addressStates = states[index];
                if (addressStates.length > 0) {
                    const suitableState = addressStates.find(
                        (state: StatesItemType) => state.value === value,
                    );
                    return {
                        value: suitableState ? suitableState.label : '',
                    };
                }
                return null;
            },
            regionId: ({value}) => ({
                value: String(value) === '0' ? INITIAL_FORM_VALUES.regionID.value : value!,
            }),
        }),
    );
